import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/components/shadcn/avatar"

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/shadcn/dropdown-menu"

import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/shadcn/sidebar"

import { Icon } from '@iconify-icon/solid';
import { UserMenu } from "../user-menu";

export function NavUser(props) {
  const { isMobile } = useSidebar()

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger as={props => <SidebarMenuButton
            size="lg"
            class="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            {...props}
          />}>
            <Avatar class="h-8 w-8 rounded-lg bg-slate-200 dark:bg-slate-800">
              <AvatarImage src={props.user.avatar} alt={props.user.name} />
              <AvatarFallback class="rounded-lg bg-slate-200 dark:bg-slate-800">
                <Icon icon="lucide:circle-user" />
              </AvatarFallback>
            </Avatar>
            <div class="grid flex-1 text-left text-sm leading-tight">
              <span class="truncate font-semibold">{props.user.name}</span>
              <span class="truncate text-xs">{props.user.email}</span>
            </div>
            <Icon icon="lucide:chevrons-up-down" class="ml-auto size-4" />
          </DropdownMenuTrigger>
          <DropdownMenuContent
            class="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
            side={isMobile() ? "bottom" : "right"}
            align="end"
            sideOffset={4}
          >
            <UserMenu user={props.user} />
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
